module.exports = __webpack_public_path__ + "371dc466d18b02cfb5698f32098f57e1.svg";